/*
 * File: /src/services/authServices.js
 * Created Date: Saturday June 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 4th July 2019 11:17:43 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

// We need naked authedAxios.so we dont intercept our intercepted request
import { authedAxios, publicAxios } from '../shared/axiosWrapper';
import {
  AD_BASE_ADMIN_PATH,
  AD_BASE_COMPANY_PATH,
  AD_BASE_ADMIN_COMPANY_PATH,
  S2_LOGIN_PATH,
  S2_VER_URL,
} from '../constants';

export default {
  /**
   * Fetch the front-end version
   *
   * @returns
   */
  fetchVersion() {
    return publicAxios.get(S2_VER_URL + 'version').then(r => {
      return r;
    });
  },


  /// SUPER ADMIN STUFF IS BELOW...
  ///  - All of this should be pulled out of this app.
  ///  -  We should have a simple way of emulating accounts from another app
  ///  -   At some point let's chat with RC about what he wants todo. 💥

  /**
   * Fetch Company Limits
   * @param {*} id Company Id
   */
  fetchCompanyLimits(id) {
    return authedAxios
      .get(AD_BASE_ADMIN_COMPANY_PATH + parseInt(id, 10) + '/limits/')
      .then(r => {
        return r;
      });
  },

  /**
   * Get Users By Company
   *
   * @param {*} id
   * @returns
   */
  listUsersByCompany(id) {
    return authedAxios
      .get(AD_BASE_ADMIN_COMPANY_PATH + parseInt(id, 10) + '/users/')
      .then(r => {
        return r;
      });
  },

  /**
   * Get User By Id
   *
   * @param {*} coId
   * @param {*} id
   * @returns
   */
  fetchUserById(coId, id) {
    return authedAxios
      .get(AD_BASE_ADMIN_COMPANY_PATH + parseInt(coId, 10) + '/users/' + id)
      .then(r => {
        return r;
      });
  },

  /**
   * Send Reset Email
   *
   * @param {*} companyId
   * @param {*} userId
   * @returns
   */
  resetPasswordUserById(companyId, userId) {
    return authedAxios.get(
      AD_BASE_ADMIN_COMPANY_PATH +
        parseInt(companyId, 10) +
        '/users/' +
        parseInt(userId, 10) +
        '/reset/'
    );
  },

  /**
   * Change Password By Id
   *
   * @param {*} companyId
   * @param {*} userId
   * @param {*} password
   * @returns
   */
  changeUserPasswordById(companyId, userId, password) {
    return authedAxios.put(
      AD_BASE_ADMIN_COMPANY_PATH +
        parseInt(companyId, 10) +
        '/users/' +
        parseInt(userId, 10) +
        '/password/',
      { password: password }
    );
  },

  emulateClient(id) {
    if (isNaN(parseInt(id, 10))) return;
    return authedAxios
      .post(S2_LOGIN_PATH + 'emulate/' + parseInt(id, 10))
      .then(r => {
        return r;
      });
  },
  stopEmulate() {
    return authedAxios
      .post(S2_LOGIN_PATH + 'emulate-exit')
      .then(r => {
        return r;
      });
  },

  refreshAccessToken(refreshToken) {
    return publicAxios
      .post(S2_LOGIN_PATH + 'refresh-token', {refreshToken: refreshToken})
      .then(r => {
        return r.data;
      });
  },

  /*
   * Get a long lived token for presenting status on a display board
   */
  getLongToken() {
    return authedAxios
      .post(S2_LOGIN_PATH + 'long-token/')
      .then(r => {
        return r;
      });
  },
};
